import { Injectable } from '@angular/core';
import { AbstractService } from './abstract-service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { AuthorizationTools } from '../tools/authorization-tools';

export interface AuthorizationState {
  fetched: boolean;
  authorities: SolAuthority[];
}

export type SolAuthority = string;

export type SolRequiredAuthorities = (SolAuthority | SolAuthority[])[];

export type SolFeature = string;

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService extends AbstractService<AuthorizationState> {
  constructor() {
    super({
      fetched: false,
      authorities: [],
    });
  }

  public setAuthorities(authorities: SolAuthority[], fetched: boolean): void {
    this.patch({
      fetched: fetched,
      authorities: authorities,
    });
  }

  public checkRouteAccess(route: ActivatedRouteSnapshot): Observable<boolean> {
    const authorities = (route.data['authorities'] as SolRequiredAuthorities) || [];
    return this.state$.pipe(
      filter(state => state.fetched),
      take(1),
      map(state => AuthorizationTools.hasAuthority(state.authorities, authorities)),
    );
  }

  /**
   * Returns an observable that emits the authorization state once authorities have been fetched.
   * Used by guards that need to check multiple authorities.
   */
  public whenFetched(): Observable<AuthorizationState> {
    return this.state$.pipe(
      filter(state => state.fetched),
      take(1),
    );
  }
}
